import React from 'react';
import { FilterDef, Settings } from '../../CommonTypes';
import { localization } from '../../localization';
import { FAButton, Separator, SlideContainer } from '../coreui';
import { Title } from '../measure_ui';
import { FiltersPane } from './FiltersPane';
import MeasurementsPane, { IImageInfo } from './MeasurementsPane';

import { PanelStyled, SPImprintStyled } from './Panel.styles';
import { ISettingsPaneProps, SettingsPane } from './SettingsPane';

export interface ISidePanelProps {
  uiAreaRef: React.RefObject<HTMLDivElement>;
  toolsAreaRef: React.RefObject<HTMLDivElement>;
  imageInfo: IImageInfo;
  overlayScale: number;
  onOverlayScaleChanged: (newScale: number) => void;
  onSaveClicked: () => void;
  onDeleteAllClicked: () => void;

  filters: FilterDef[];
  filterValues: number[];
  onFilterChanged: (newVals: number[]) => void;

  settings: Settings;
  settingProps: ISettingsPaneProps;
  
  openLink: (link: string, newTab: boolean) => void;
  onShowAbaout: () => void;
  logoPath: string;
  homePage: string;
}

export interface ISidePanelState {
  openPanel: number;
}

export class SidePanel extends React.Component<ISidePanelProps, ISidePanelState> {
  constructor(props: ISidePanelProps) {
    super(props);

    this.state = {
      openPanel: 0
    }
  }

  public render() {
    const loc = localization[this.props.settings.lang];

    const PanelMeasurements = (
      <MeasurementsPane toolsAreaRef={this.props.toolsAreaRef} uiAreaRef={this.props.uiAreaRef} settings={this.props.settings}
        imageInfo={this.props.imageInfo} overlayScale={this.props.overlayScale}
        onOverlayScaleChanged={this.props.onOverlayScaleChanged}
        onDeleteAllClicked={this.props.onDeleteAllClicked}/>
    );

    const PanelFilters = <FiltersPane settings={this.props.settings} onFilterChanged={this.props.onFilterChanged} values={this.props.filterValues} filters={ this.props.filters }/>

    const PanelSettings = <SettingsPane {...this.props.settings } {...this.props.settingProps} />
    
    const Imprint = (
      <SPImprintStyled>
        <FAButton id='AboutButton' size={45} icon={'question-circle'} onClick={this.props.onShowAbaout}
          data-tip={ loc.tooltips.about }/>
        <span onClick={() => this.props.openLink(loc.imprintLink, true)}><u>{loc.imprint}</u></span>
        <span onClick={() => this.props.openLink(loc.privacyPolicyLink, true)}><u>{loc.privacyPolicy}</u></span>
      </SPImprintStyled>
    );

    return (
      <PanelStyled>
        <Title logoPath={ this.props.logoPath } style={{ cursor: 'pointer' }}
          onClick={() => this.props.openLink(this.props.homePage, true)} />
        <Separator />
        <div id='SlideArea'>
          <SlideContainer slideStyle='slide' openElem={this.state.openPanel} transitionDuration={this.props.settings.transitionDuration}
            onHeadingClick={val => this.setState({ openPanel: val })} titleExtra={
              <FAButton icon='save' size={35} onClick={this.props.onSaveClicked} data-tip={ loc.tooltips.save } />
          } elements={[
          { heading: loc.measurements.title, content: PanelMeasurements },
          { heading: loc.filterTitle, content: PanelFilters },
          { heading: loc.settingsTitle, content: PanelSettings }
        ]} />
        </div>
        { Imprint }
      </PanelStyled>
    );
  }
}
